(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const cartCountBubble = document.getElementById('cart-count-bubble');

    function updateCartCount(cart) {
      if (!cartCountBubble) return;
      const itemCount = cart?.item_count ?? 0;

      if (itemCount > 0) {
        cartCountBubble.textContent = itemCount;
        cartCountBubble.removeAttribute('hidden');
      } else {
        cartCountBubble.setAttribute('hidden', '');
      }
    }

    function fetchAndUpdateCart() {
      fetch('/cart.js')
        .then((res) => res.json())
        .then((cart) => updateCartCount(cart))
        .catch(() => {});
    }

    document.addEventListener('cart:updated', (e) => {
      if (e.detail?.cart) {
        updateCartCount(e.detail.cart);
      }
    });

    document.addEventListener('cart:added', () => {
      fetchAndUpdateCart();
    });

    if (window.Cart) {
      const currentCart = window.Cart.getCart();
      if (currentCart) {
        updateCartCount(currentCart);
      } else {
        window.Cart.fetchCart()
          .then((cart) => {
            updateCartCount(cart);
          })
          .catch(() => {});
      }
    }

    const burgerToggle = document.querySelector('[data-burger-toggle]');
    const slideMenu = document.querySelector('[data-slide-menu]');
    const slideMenuClose = document.querySelector('[data-slide-menu-close]');
    const backdrop = document.querySelector('[data-backdrop]');
    const headerShell = document.querySelector('[data-header-shell]');
    const headerSectionWrapper = headerShell?.closest('.shopify-section');

    if (headerSectionWrapper) {
      headerSectionWrapper.classList.add('shopify-section-header-sticky');
      headerSectionWrapper.style.zIndex = '30';
    }

    function updateHeaderState() {
      headerShell?.classList.toggle('is-scrolled', window.scrollY > 4);
    }

    updateHeaderState();
    window.addEventListener('scroll', updateHeaderState, { passive: true });

    function openMenu() {
      if (slideMenu) slideMenu.classList.add('is-open');
      if (slideMenu) slideMenu.setAttribute('aria-hidden', 'false');
      if (burgerToggle) burgerToggle.setAttribute('aria-expanded', 'true');
      if (backdrop) backdrop.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
      slideMenuClose?.focus();
    }

    function closeMenu() {
      if (slideMenu) slideMenu.classList.remove('is-open');
      if (slideMenu) slideMenu.setAttribute('aria-hidden', 'true');
      if (burgerToggle) burgerToggle.setAttribute('aria-expanded', 'false');
      if (backdrop) backdrop.classList.remove('is-visible');
      document.body.style.overflow = '';
    }

    if (burgerToggle) {
      burgerToggle.addEventListener('click', openMenu);
    }

    if (slideMenuClose) {
      slideMenuClose.addEventListener('click', closeMenu);
    }

    if (backdrop) {
      backdrop.addEventListener('click', closeMenu);
    }

    slideMenu?.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && slideMenu?.classList.contains('is-open')) {
        closeMenu();
      }
    });

    document.querySelectorAll('.header__cta-button[href^="#"]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        const targetId = btn.getAttribute('href').substring(1);
        const target = document.getElementById(targetId);
        if (target) {
          e.preventDefault();
          closeMenu();
          const headerHeight = document.querySelector('[data-header]')?.offsetHeight || 0;
          const top = target.getBoundingClientRect().top + window.scrollY - headerHeight - 16;
          window.scrollTo({ top, behavior: 'smooth' });
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
